import { Injectable } from '@angular/core';
import { TranslationRuntimeService } from './translation-runtime.service';

// a ténylegesen dinamikus/futásidőben összefűzött kulcsokhoz (pl. backend hibakód-prefix + kód),
// amik nem migrálhatók natív i18n/$localize-ra, mert a message-id-nak fordítási időben
// statikusan ismertnek kell lennie. Ugyanazt a target || hint || key fallback-logikát
// követi, mint a mai CustomTranslateParser.
@Injectable({
  providedIn: 'root',
})
export class DictionaryLookupService {
  constructor(private runtime: TranslationRuntimeService) {}

  get(key: string, fallback?: string): string {
    return this.runtime.getRaw(key, fallback);
  }
}
